import QRCode from "react-qr-code";

export default function QRCodeGenerator({value, style} : {value: string, style?: any}) {

    return(<div style={style}><QRCode value={value} /></div>)

}